module.exports = __webpack_public_path__ + "img/logo.e90b339c.svg";